import {changeClaimChecks, ClaimActionType, getClaimChecks} from 'Agent/Claims/ducks/claim';
import {Check} from 'Agent/Claims/models/Check';
import {Claim} from 'Agent/Claims/models/Claim';
import {AsyncResult, fromResult, Loading, ServerError} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {flow} from 'fp-ts/lib/function';
import * as NEA from 'fp-ts/lib/NonEmptyArray';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {eq} from 'Shared/utilities/equals';
import {get} from 'Shared/utilities/fetchHelpers';
import {removeApiPrefix} from 'Shared/utilities/PageUtility';
import {prop} from 'Shared/utilities/prop';

const getCheckUri = (encryptedIdentifier: string) =>
  flow(
    prop<Claim, 'links'>('links'),
    O.fromNullable,
    O.chain(NEA.fromArray),
    O.chain(NEA.filter(eq('rel', 'details'))),
    O.map(NEA.head),
    O.map(prop('href')),
    O.chain(O.fromNullable),
    O.map(removeApiPrefix),
    O.map(uri => `${uri}&${addFilterParameters({encryptedIdentifier}).slice(1)}`)
  );

function* getChecksSaga() {
  yield takeLatest(ClaimActionType.GET_CLAIM_CHECKS, function*(action: ReturnType<typeof getClaimChecks>) {
    const {claim, encryptedIdentifier} = action.payload;

    yield put(changeClaimChecks(new Loading()));

    yield pipe(
      getCheckUri(encryptedIdentifier)(claim),
      O.fold(
        () => put(changeClaimChecks(new ServerError('Unable to Retrieve Checks'))),
        function* loadCheck(checkUri: string): unknown {
          const checks: AsyncResult<Check[]> = yield call(get, checkUri);

          if (E.isRight(checks)) {
            yield put(changeClaimChecks(fromResult(checks.right)));
          } else {
            yield put(changeClaimChecks(new ServerError('Unable to Retrieve Checks')));
          }
        }
      )
    );
  });
}

export default function*() {
  yield all([getChecksSaga()]);
}
